import { render, staticRenderFns } from "./SurfaceDesignTextures.vue?vue&type=template&id=5574ddcd"
import script from "./SurfaceDesignTextures.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignTextures.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignTextures.vue?vue&type=style&index=0&id=5574ddcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports